import React from 'react';
import ImageUploader from "../ImageUpload/ImageUploader";
import CircularProgress from 'material-ui/CircularProgress';
import Toggle from 'material-ui/Toggle';
import Solution from './Solution';
import ReactTooltip from 'react-tooltip';

var MCQuestionEditor = React.createClass({
  newMCQuestion: function() {
    return [{
      text: "",
      image: "",
      answerValue: 1
    }, {
      text: "",
      image: "",
      answerValue: 0
    }, {
      text: "",
      image: "",
      answerValue: 0
    }, {
      text: "",
      image: "",
      answerValue: 0
    }];
  },
  verifyQuestionData: function() {
    var kquestion = this.state.kquestion;
    if (kquestion.type !== 11) return;
    kquestion.textInputAnswers = [];
    if (!kquestion.selectionChoices || kquestion.selectionChoices.length === 0) {
      kquestion.selectionChoices = this.newMCQuestion();
    }
    for (var i = 0; i < kquestion.selectionChoices.length; i++) {
      if (kquestion.selectionChoices[i].image) kquestion.answerHasImage = true;
    }
    this.setState({
      kquestion: kquestion
    });
  },
  getInitialState: function() {
    return {
      kquestion: this.props.kquestion
    };
  },
  componentWillMount: function() {
    this.verifyQuestionData();
  },
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      kquestion: nextProps.kquestion
    })
  },
  handleDescriptionChange: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.description = e.target.value;
    this.setState({
      kquestion: kquestion
    })
    // this.state.kquestion.description = e.target.value;
    // this.forceUpdate();
  },
  handleAnswerValueChange: function(choice, e) {
    // console.log("INSIDE HANDLE ANSEWR VALUE CHANGE");
    // console.log("AND BEFORE KQUESTION IS " + JSON.stringify(this.state.kquestion));
    // console.log("AND NEW CHOICE IS " + JSON.stringify(choice));
    // console.log("AND NEW E IS " + e);
    var kquestion = this.state.kquestion;
    for (var i = 0; i < kquestion.selectionChoices.length; i++) {
      if (i === kquestion.selectionChoices.indexOf(choice)) kquestion.selectionChoices[i].answerValue = e.target.checked ? 1 : 0;
      else kquestion.selectionChoices[i].answerValue = 0;
    }
    console.log("AND AFTER KQUESTION IS " + JSON.stringify(this.state.kquestion));
    this.setState({
      kquestion: kquestion
    })
  },
  handleOptionTextChange: function(choice, e) {
    // var kquestion = this.state.kquestion;
    choice.text = e.target.value;
    this.forceUpdate();
  },
  addOption: function() {
    var kquestion = this.state.kquestion;
    kquestion.selectionChoices.push({
      text: "",
      image: "",
      answerValue: 0
    });
    this.setState({
      kquestion: kquestion
    })
  },
  handleRemoveOption: function(choice) {
    var kquestion = this.state.kquestion;
    var optionIndex = kquestion.selectionChoices.indexOf(choice);
    kquestion.selectionChoices.splice(optionIndex, 1);
    this.setState({kquestion: kquestion});
  },
  uploadImageDone: function(modelToBind, response) {
    modelToBind.isImageUploading = false;
    modelToBind.image = response.url;
    this.forceUpdate();
  },
  onUploadingImage: function(modelToBind) {
    modelToBind.isImageUploading = true;
    this.forceUpdate();
  },
  toggleAnswerWithImage: function(e) {
    var kquestion = this.state.kquestion;
    kquestion.answerHasImage = e.target.checked;
    this.setState({
      kquestion: kquestion
    })
  },
  removeImage: function(model, e) {
    e.stopPropagation();
    model.image = '';
    this.forceUpdate();
  },
  render: function() {
    var _this = this;
    return (
      <div className="question-content-container">
        <div className="row">
          <div className="col-md-6 col-xs-12">
            <ImageUploader onUploading={_this.onUploadingImage.bind(_this, _this.state.kquestion)} onUploadDone={_this.uploadImageDone.bind(_this, _this.state.kquestion)}>
              { !_this.state.kquestion.image &&
                <div>
                  <div className="img-intrinsic input intrinsic-2x1" style={{"background": "#ddd"}}>
                    {_this.state.kquestion.isImageUploading &&
                      <div className="intrinsic-item">
                        <CircularProgress className="loading"/>
                      </div>}
                  </div>
                  <div className="img-text-placehoder">
                      Click here to upload picture
                  </div>
                </div>
              }
              {
                _this.state.kquestion.image &&
                <div>
                  <div className="remove-image" data-tip data-for={"tt-remove-image-description"} onClick={_this.removeImage.bind(_this, _this.state.kquestion)}>
                    <i className="fa fa-remove"></i>
                  </div>
                  <img src={_this.state.kquestion.image} style={{"width": "100%"}} alt="Question"/>
                  <ReactTooltip id="tt-remove-image-description" effect="solid">Remove image</ReactTooltip>
                </div>
              }
            </ImageUploader>
          </div>
          <div className="col-md-6 col-xs-12">
            <textarea className="form-control" placeholder="Enter question title here" rows="6" onChange={_this.handleDescriptionChange} value={_this.state.kquestion.description}></textarea>
          </div>
        </div>
        <hr/>
        <div style={{"marginBottom": "10px", width: "200px"}}>
          <Toggle onToggle={_this.toggleAnswerWithImage} toggled={_this.state.kquestion.answerHasImage}
            label="Answer with Images"
            labelPosition="right"
          />
        </div>
        <div className="choices">
          {
            _this.state.kquestion.selectionChoices.map(function(choice, index) {
              return (
                <div className={"choice " + (choice.answerValue > 0 ? "is-right" : "")} key={index}>
                  <div className="choice-value">
                    <input className="" type="radio" id={"mcq-question-" + _this.props.questionIndex + "-" + index} onChange={_this.handleAnswerValueChange.bind(_this, choice)} checked={choice.answerValue > 0 ? "checked" : ""}/>
                    <label htmlFor={"mcq-question-" + _this.props.questionIndex + "-" + index}></label>
                  </div>
                  <div className="choice-text dp-table">
                    {
                      _this.state.kquestion.answerHasImage &&
                      <div style={{"width": "150px"}} className="dp-table-cell">
                        <ImageUploader onUploading={_this.onUploadingImage.bind(_this, choice)} onUploadDone={_this.uploadImageDone.bind(_this, choice)}>
                          { !choice.image &&
                            <div>
                              <div className="img-intrinsic input small intrinsic-2x1" style={{"background": "#ddd"}}>
                                {choice.isImageUploading &&
                                  <div className="intrinsic-item">
                                    <CircularProgress className="loading"/>
                                  </div>}
                              </div>
                              <div className="img-text-placehoder" style={{fontSize: "11px"}}>
                                  Click here to upload picture
                              </div>
                            </div>
                          }
                          {
                            choice.image &&
                            <div>
                              <div className="remove-image" data-tip data-for={"tt-remove-image-answer-" + index} onClick={_this.removeImage.bind(_this, choice)}>
                                <i className="fa fa-remove"></i>
                              </div>
                              <img src={choice.image} style={{"width": "100%"}} alt="Question"/>
                              <ReactTooltip id={"tt-remove-image-answer-" + index} effect="solid">Remove image</ReactTooltip>
                            </div>
                          }
                        </ImageUploader>
                      </div>
                    }
                    <div className="dp-table-cell" style={{"paddingLeft": "10px"}}>
                      <input type="text" className="form-control" placeholder="Enter answer here" onChange={_this.handleOptionTextChange.bind(_this, choice)} value={choice.text}/>
                    </div>
                    <div
                      className="dp-table-cell text-center choice-remove"
                      onClick={_this.handleRemoveOption.bind(_this, choice)}
                      data-tip data-for={"tt-answer-" + index}>
                      <i className="fa fa-remove"></i>
                    </div>
                    <ReactTooltip id={"tt-answer-" + index} effect="solid">Remove answer</ReactTooltip>
                  </div>
                </div>
              )
            })
          }
          <button className="btn btn-primary" onClick={_this.addOption}>Add option</button>
        </div>
        <hr/>
        {/*<Solution kquestion={_this.state.kquestion}/>*/}
        <Solution solution={_this.state.kquestion.solution} type={11}/>
      </div>
    )
  },
  componentDidMount: function() {

  }
})

export default MCQuestionEditor;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/MCQuestion.js
 **/